import { HappyHourDTO } from 'types';
import { deviceApi } from './device';

export interface CartridgesUpdateDto {
  DeviceId: string;
}

const happyHourApi = deviceApi
  .enhanceEndpoints({
    addTagTypes: ['HappyHour'],
  })
  .injectEndpoints({
    endpoints: ($) => ({
      getDeviceHappyHour: $.query<HappyHourDTO, string>({
        query: (deviceId: string) => ({
          url: `/devices/${deviceId}/happyhour`,
          method: 'GET',
        }),
        providesTags: (_res, _err, deviceId) => [
          { type: 'HappyHour', id: deviceId },
        ],
      }),
      getIsDeviceHappyHourEnabled: $.query<boolean, string>({
        query: (deviceId: string) => ({
          url: `/devices/${deviceId}/ishappyhour`,
          method: 'GET',
        }),
        keepUnusedDataFor: 0,
      }),
      updateDeviceHappyHour: $.mutation({
        query: ({
          deviceId,
          ...data
        }: { deviceId: string } & HappyHourDTO) => ({
          url: `/devices/${deviceId}/happyhour`,
          method: 'POST',
          data,
          responseType: 'text',
        }),
        invalidatesTags: (_res, _err, params) => [
          { type: 'HappyHour', id: params.deviceId },
        ],
      }),
    }),
  });

export const {
  useGetDeviceHappyHourQuery,
  useUpdateDeviceHappyHourMutation,
  useGetIsDeviceHappyHourEnabledQuery,
} = happyHourApi;
